import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import withDefaultProps from 'helpers/withDefaultProps';
import * as Ui from './Button.styles';

const Button = forwardRef(({ className = '', children, $type, ...restProps }, ref) => (
  <Ui.BootstrapButton $type={$type} className={`${className}`} {...restProps} ref={ref}>
    {children}
  </Ui.BootstrapButton>
));

Button.propTypes = {
  $type: PropTypes.oneOf(['avedaPrimary', 'avedaPrimaryOutline', 'avedaSecondary', 'avedaDanger']),
  ...withDefaultProps(),
};

export default Button;
